import ShopIcon from '../../assets/icons/ShopIcon';
import LinkButton from '../../components/linkButton/LinkButton';
import Emitter from '../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../services/eventEmmiter/EventTypes';
import { BasketService } from '../../services/basket/BasketService';
import { IBasketItem } from '../../services/productService/models/IBasketItem';
import { IBasketModel } from '../../services/productService/models/IBasketModel';
import * as style from './style.css';
import * as appStyle from '../../styledApplication/style.css';
import React = require('react');

interface IProps {
    basketUri: string;
    productUri: string;
}

interface IState {
    basket: IBasketModel;
    showProducts: boolean;
}

export default class BasketMenuItem extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            basket: null,
            showProducts: true
        };
    }

    basketService: BasketService;

    componentDidMount() {
        this.basketService = BasketService.Instance();
        Emitter.on(EventTypes.Shopping, () => this.updateBasket());
        this.updateBasket();
    }

    updateBasket() {
        this.basketService.calculateBasket((basket: IBasketModel) => {
            this.setState({ basket: basket }, () => {
                Emitter.emit(EventTypes.UserData, basket.endUser);
            });
        }
        );
    }

    render() {
        let itemsCount = 0;
        if (this.state.basket) { itemsCount = this.state.basket.summary.itemCount; }
        return (
            <div className={style.basketWrapper} >

                <a href={this.props.basketUri} style={{ display: 'flex' }}>
                    <div className={appStyle.xlarge}>
                        <ShopIcon fontSize={'30px'} />
                    </div>
                    {itemsCount > 0 &&
                        <div className={style.basketSummary} > {this.state.basket.summary.itemCount} poz.</div>
                    }
                </a>
                {this.showProducts() && <div className={style.basketItems}>
                    {this.state.basket.items.map(item => this.renderItem(item))}
                    <div className={style.basketTotal}>
                        Razem: {this.state.basket.summary.total.toFixed(2)} zł
                        <div style={{ margin: '15px' }}>
                            <LinkButton
                                label={'Przejdź do koszyka'}
                                link={this.props.basketUri}
                            >
                                <ShopIcon />
                            </LinkButton>
                        </div>
                    </div>
                </div>
                }
            </div>
        );
    }

    renderItem(i: IBasketItem): any {
        const prodUri = `${this.props.productUri}/${i.slug}`;
        return <div className={style.basketItem} key={i.slug}>
            <div className={style.thumbnail}>
                <div className={style.imgWrapper} >
                    <a href={prodUri}>
                        <img src={i.thumbnail + '/100'}></img>
                    </a>
                </div>
            </div>
            <div className={style.itemInfo}>
                <a href={prodUri} >
                    <div className={style.itemName}>
                        {i.name}</div>
                </a>
                <div className={style.itemDetail}>

                    <div className={style.itemQty}>{i.quantity} szt.</div>
                    <div className={style.detailTotal}>
                        <div>{i.price.toFixed(2)} zł</div>
                    </div>
                </div>
            </div>
        </div>;
    }

    showProducts() {
        return this.state.showProducts && this.state.basket;
    }
}
